/*****************************************************************************
 * NOTICE appModules will auto generate when run register module script.
 * PLEASE DO NOT change it manually
 *****************************************************************************
 */

// IMPORT_APP_MODULES
import { AdministratorModule } from "./modules/administrator/administrator.module";
import { CategoryModule } from "./modules/category/category.module";
import { ExploreModule } from "./modules/explore/explore.module";
import { HomepageModule } from "./modules/home/homepage.module";
// import { MailModule } from "./modules/mail/mail.module";
// import { NotificationModule } from "./modules/notification/notification.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { LightboxModule } from "ngx-lightbox";
import { ToastrModule } from "ngx-toastr";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthCamerallaInterceptor } from "./auth/interceptors/auth.interceptor";
import { ErrorCamerallaInterceptor } from "./auth/interceptors/error.interceptor";
import { systemThirdPartiesForRoot } from "./core/config/third-party.config";
import { CoreModule } from "./core/core.module";
import { AuthModule } from "./modules/auth/auth.module";
import { DigitalMemoryLogModule } from "./modules/digital-memory-log/digital-memory-log.module";
import { LadipageModule } from "./modules/ladipage/ladipage.module";
import { LandingpageModule } from "./modules/landingpage/landingpage.module";
import { PhotoModule } from "./modules/photo/photo.module";
import { PresetModule } from "./modules/preset/preset.module";
import { SearchModule } from "./modules/search/search.module";
import { UploadModule } from "./modules/upload/upload.module";
import { SharedModule } from "./shared/shared.module";

const appModules = [
  AdministratorModule,
  CategoryModule,
  ExploreModule,
  HomepageModule,
  // NotificationModule,
  PhotoModule,
  SearchModule,
  UploadModule,
  PresetModule,
  AuthModule,
  LadipageModule,
  DigitalMemoryLogModule,
];
// END_IMPORT_APP_MODULES

const angularModules = [
  BrowserModule.withServerTransition({ appId: "arodit" }),
  ServiceWorkerModule.register("/ngsw-worker-polyfill.js", {
    enabled: environment.serviceWorker && environment.production,
  }),
  HttpClientModule,
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    ...angularModules,
    ...systemThirdPartiesForRoot,
    SharedModule,
    CoreModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
    LightboxModule,
    LandingpageModule,
    ...appModules, // please dont change order of import
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthCamerallaInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCamerallaInterceptor,
      multi: true,
    },
    // {
    //   provide: RouteReuseStrategy,
    //   useClass: CustomReuseStrategy,
    // },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
